import React from 'react';
import './Sections.css';

const TheGreenHood = () => {
  return (
    <div className="thegreenhood-container">
      <div className="text-box">
        <div className="inner-box" dir="rtl">
          <h2>הברדס הירוק</h2>
          <p>האקינג הוא תחום של חקירה ופיצוח תעלומות. זהו מסע לגילוי הנסתר, לפתיחת דלתות נעולות ולמציאת דרכים חדשות במקומות שעל פניו נראים בלתי חדירים.</p>
          <p>אם יש בכם את הסקרנות והנחישות לחקור את הגבולות, אתם מוזמנים לגלות את האקר שבתוככם. הכלים שתרכשו כאן יאפשרו לכם לראות מעבר למה שאחרים רואים, לפצח לא רק קודים אלא גם אתגרים, ולהגיע למחוזות שאחרים רק חולמים עליהם. אני הברדס הירוק שלכם, והמסע שלנו יחד מתחיל כאן.</p>
          <p>המטרה שלנו ברורה: אנחנו פורצים על מנת להגן, תוקפים על מנת להתמגן. אנחנו רוצים להפוך את העולם לבטוח יותר, כך שנמצא את הפרצות לפני שפושעים ישתמשו בהן על מנת לפגוע ולהרוויח לטובתם האישית.</p>
          <p>מאחורי הברדס מסתתר ידע רב ויכולת לחשוב אחרת, לראות דברים מזווית שונה ולפתור בעיות מורכבות. אם אתם מתחילים את דרככם בעולם הסייבר או כבר מנוסים ומחפשים שותף לפרויקט הבא - בואו נצא יחד למסע ונגלה את הנתיבים הנסתרים של הרשת שממתינים רק למי שיודע לחפש אותם.</p>
        </div>
      </div>
    </div>
  );
};

export default TheGreenHood;